import File from "@/scripts/models/file.model";
export default class ImageInstitution {

    constructor() {
        this.id = 0;
        this.institutionId = 0;
        this.file = new File();
        this.order = 0;
    }
}